import SelectMerchantComponent from "./select-merchant";
import OptionItemComponent from './option-item';


export const SelectMerchant = SelectMerchantComponent;
export const OptionItem = OptionItemComponent;

export default SelectMerchant;